import { post, get } from './index'
import { request as ajax } from '@/utils/axios'
import axios from 'axios'
import config from '@/config'
export function transformPost(url, params, other = {}) {
  return ajax(
    {
      url,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        loginToken: sessionStorage.getItem('loginToken'),
      }, // 头部信息处理
      error: false,
    },
    {
      prefix: config.mobServer,
      ...other,
    }
  )
}
// 香港专题活动优惠券列表
export function getHongKongActivityCouponList(params) {
  return post('/coupon/list/activity/hongkong', params)
}

// 我的优惠券列表
export function getMyCouponList(params) {
  return post('/coupon/my-coupon', {
    ...params,
  })
}

export function getCouponWindowDetail(params) {
  return get('/coupon/window/detail', params)
}

// 优惠券详情
export function getCouponDetail(params) {
  return transformPost('/coupon/detail', params)
}

// 优惠券券码兑换
export function couponRedeem(params) {
  return post('/coupon/redeem', params)
}

// 优一级品类查询
export function getFirstProductClass(params) {
  return get('/coupon/first-product-class', params)
}

//查询即将过期优惠券
export function getExistsWillExpire(params) {
  return get('/coupon/exists/will-expire', params)
}

//领取优惠券
// export function getReceiveCoupon(params) {
//   return post('/coupon/receive', params)
// }

//领取优惠券
// export function getFirstProductClass(params) {
//   return get('/coupon/first-product-class', params)
// }

//我的优惠券

export function getMyCoupon(params) {
  return post('/coupon/my-coupon', params)
}

//优惠券中心查询可领取优惠券

export function getReceivableCoupon(params) {
  return post('/coupon/receivable', params)
}

//我的优惠券历史

export function getMyCouponHistory(params) {
  return post('/coupon/history/my-coupon', params)
}

//领取优惠券
export function getReceiveCoupon(params) {
  return post('/coupon/receive', params)
}

//领取优惠券
// export function getFirstProductClass(params) {
//   return get('/coupon/first-product-class', params)
// }

//领取优惠券包2
export function getListActivity(params) {
  return post('/coupon/list/activity', params)
}
//批量领取优惠券
export function getReceiveCouponBatch(params) {
  return post('/coupon/receive/batch', params)
}

//获取会员等级券包列表
export function getListActivityByMemberLevel(params) {
  return get('/coupon/list/activity/member-level', params)
}
// 我的优惠券列表
export function getCouponListNew(params) {
  return post('/coupon/my-coupon-v1', params)
}

// 获取活动链接
export function getRewardDashboard(params) {
  return post('/fission/reward-dashboard', params)
}

// 提交邀请码
export function submitInviteCode(params) {
  return post('/fission/fill-code', params)
}

// 获取邀请码
export function getInviteCode() {
  return get('/fission/generate-code')
}

// 获取邀请奖励列表
export function getInviteRewardList(params) {
  return post('/fission/invite-reward-list', params)
}

// 获取会员奖励信息
export function getMemberReward(params) {
  return post('/fission/member-reward', params)
}
